export class CardPaymentDetailDto {

    amount: number;
    bankName: string;
    date: string;
    cardNo: string;
    cardType: string;
    cardHolderName: string;
    transactionID: string;
    refNo: string;
    cardCode: string;
}
